import { Box, styled } from "@mui/material";
import Grid from "@mui/material/Grid2";
export const StyledWrapper = styled(Box)(() => ({
  width: "100%",
  // height: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}));
export const StyledWelcomeBanner = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.extraSmall.fontSize,
  height: "100%",
}));
export const StyledGridContainer = styled(Grid)(({ theme }) => ({

  background: theme.palette.custom.white,
  borderRadius: theme.borderRadius.radius.regular,
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  border: theme.borders.highlighted,
}));
export const StyledGridContainerPack = styled(Grid)(({ theme }) => ({
  background: theme.palette.custom.white,
  borderRadius: theme.borderRadius.radius.custom,
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
}));
export const StyledGridBorder = styled(Grid)(({ theme }) => ({
  borderRight: theme.borders.highlighted,
  [theme.breakpoints.down("lg")]: {
    borderRight: "none",
    borderBottom: theme.borders.highlighted,
  },
}));
